<template>
    <div>
        <ScenarioSplashPage
            :primaryTitle="title"
            :primarySubtitle="subtitle"
            :secondaryContent="content"
            buttonLabel="Deploy"
            :bgImage="bgImage"
            @deploy="deploy"
        />
    </div>
</template>

<script>
import ScenarioSplashPage from '@/components/ScenarioSplashPage'

export default {
    components: {
        ScenarioSplashPage,
    },
    computed: {
        SCENARIO() { return this.$root.calcIDs().scenario },
        STAGE() { return this.$root.calcIDs().stage },
        title() { return this.$root.scenarioText[this.SCENARIO].title },
        subtitle() { return this.$root.scenarioText[this.SCENARIO].subtitle },
        content() { return this.$root.scenarioText[this.SCENARIO][this.STAGE].content },
        bgImage() { return this.$root.scenarioText[this.SCENARIO][this.STAGE].bgImage },
    },

    methods: {
        deploy() {
            this.$root.deploy()
        },
        handleKeys(e) {
            this.$root.handleSplashKeys(e)
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeys)
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeys)
    },
}
</script>
